export default __webpack_public_path__ + "static/media/Icon-Krankheitsbilder.a901432d.svg";